import { ItemSummaryPage, type ItemSummaryPageRows } from "./ItemSummaryPage";
import type { StoreDetail } from "./PageMerchflows_ExportPdf_StorePogId";

interface ItemSummaryPagesListProps {
  itemSummaryPages: ItemSummaryPageRows[];
  storeDetail: StoreDetail | null;
  itemSummaryStartPageNumber: number;
  totalPages: number;
}

export const ItemSummaryPagesList = ({
  itemSummaryPages,
  storeDetail,
  itemSummaryStartPageNumber,
  totalPages,
}: ItemSummaryPagesListProps) => {
  return (
    <>
      {itemSummaryPages.map((itemSummaryPage, index) => (
        <ItemSummaryPage
          key={`${storeDetail?.store || "summary"}-${index}`}
          storeDetail={storeDetail}
          page={itemSummaryPage}
          pageNumber={itemSummaryStartPageNumber + index}
          totalPages={totalPages}
        />
      ))}
    </>
  );
};
